import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { stopEventRefs } from "../subjects/stopEvent/refs";

/**
 * Which end of the driver's day the inspection belongs to.
 */
export const DvirPhaseSchema = z.enum(["preTrip", "postTrip"]).openapi("DvirPhase");

export type DvirPhase = z.infer<typeof DvirPhaseSchema>;

/**
 * The driver completed a vehicle inspection report.
 */
export const dvirV1 = tmsEventKind(
  { category: "inspection", kind: "dvir", version: 1 },
  {
    refs: stopEventRefs,
    facts: {
      phase: DvirPhaseSchema,
      stopName: z.string(),
    },
  },
);

export const DvirV1Schema = dvirV1.schema;
export const DvirV1FactsSchema = dvirV1.facts;

export type DvirV1 = z.infer<typeof DvirV1Schema>;
export type DvirV1Facts = z.infer<typeof DvirV1FactsSchema>;

/** Every version of `dvir`, keyed by version. What `catalog.ts` places under `inspection`. */
export const dvir = { 1: dvirV1 } as const;
